/* eslint-disable no-redeclare */
import { UUID } from '@hc-frontend/core-types';
import type { z } from 'zod';

export const AdImpression = UUID;

export type AdImpression = z.infer<typeof AdImpression>;
